// EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.REWARD_CARD

export const REWARD_CARD = {
  REDEEMED_ITEM: 'reward_card-redeemed_item'
};
